import GameWorld from '@/webgl/runner/GameWorld'
import { ISystem } from '@/webgl/runner/interfaces/ISystem'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type SystemType = new (...args: any[]) => ISystem

export default class SystemRegistry {
  private _world: GameWorld
  private _systems: ISystem[] = []
  private _systemsMap: Map<SystemType, ISystem> = new Map()

  constructor(world: GameWorld) {
    this._world = world
  }

  dispose() {
    for (let i = this._systems.length - 1; i >= 0; i--) {
      this.remove(this._systems[i])
    }
  }

  add(system: ISystem): SystemRegistry {
    const type = system.constructor as SystemType
    this._systemsMap.set(type, system)
    this._systems.push(system)
    return this
  }

  remove(system: ISystem) {
    const index = this._systems.indexOf(system)
    system.dispose()
    this._systems.splice(index, 1)
    this._systemsMap.delete(system.constructor as SystemType)
  }

  start() {
    for (const system of this._systems) {
      system.start?.()
    }
  }

  get<T extends ISystem>(type: SystemType): T {
    return this._systemsMap.get(type) as T
  }

  forEach(callback: (system: ISystem) => void) {
    for (const system of this._systems) {
      callback(system)
    }
  }
}
